import { Form, Select } from "antd";

import { filterOption } from "./filter-option";
import { getSelectOptions } from "../../utils/get-select-options";
import { pickFormItemProps, pickSelectProps } from "./pick-props";
import { reduceGroupByOptions } from "./reduce-group-by-options";
import { useContacts } from "../../data/use-contacts";

export const ContactSelect = (props) => {
  const contacts = useContacts();

  const form = Form.useFormInstance();
  const initialValue = form.getFieldValue(props.name);

  let options = getSelectOptions({
    store: contacts,
    initialIds: initialValue,
    filter: props.filter,
    labelKey: "alias",
  });

  options = reduceGroupByOptions(
    options,
    props.groupBy,
  );

  return (
    <Form.Item {...pickFormItemProps(props)}>
      <Select
        showSearch
        optionFilterProp="children"
        filterOption={filterOption}
        options={options}
        {...pickSelectProps(props)}
      />
    </Form.Item>
  );
};
